import { Routes } from '@angular/router';
import { permissionGuard } from '@core/auth/permission.guard';
import { APP_PERMISSIONS } from '@core/constants/permission.constants';
import { APP_ROUTES } from '@core/constants/routes.constants';

export const rolesRoutes: Routes = [
  {
    title: 'pagesTitles.roles',
    path: APP_ROUTES.ROLES,
    canActivate: [permissionGuard(APP_PERMISSIONS.RolesRead)],
    loadComponent: () => import('./pages/roles-list').then((m) => m.RolesList),
  },
  {
    title: 'pagesTitles.rolePermissions',
    path: APP_ROUTES.ROLES_PERMISSIONS,
    canActivate: [permissionGuard(APP_PERMISSIONS.RolesRead)],
    loadComponent: () =>
      import('../role-permissions/pages/role-permissions-panel').then(
        (m) => m.RolePermissionsPanel
      ),
  },
];
